import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import makeStyles from "@mui/styles/makeStyles";
//limitless imports
import CompleteIncompleteIcon from "../../components/complete-incomplete-icon/CompleteIncompleteIcon";
const useStyles = makeStyles(theme => ({
  container: {
    paddingTop: 5
  },
  customCompleteContainer: {
    height: 24,
    width: 24
  },
  contentContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "nowrap"
  },
  gridItemContent: {
    display: "flex"
  },
  paperContainer: {
    padding: 24,
    borderRadius: 12,
    wordBreak: "break-word",
    width: "100%"
  },
  listItem: {
    paddingTop: 24,
    display: "flex",
    alignItems: "center"
  },
  listItemText: {
    paddingLeft: 16
  },
  listItemSucessIcon: {
    color: theme.palette.success.main
  }
}));
const CanCannotAnswer = ({
  content,
  leftSpaceContainer,
  bottomSpaceContainer = ""
}) => {
  const classes = useStyles();
  const contentItems = [{
    header: content.header1,
    list: content.list1,
    canAnswer: true
  }, {
    header: content.header2,
    list: content.list2,
    canAnswer: false
  }];
  return /*#__PURE__*/React.createElement(Grid, {
    className: `${leftSpaceContainer} ${bottomSpaceContainer} ${classes.container}`
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.contentContainer
  }, contentItems.map((contentItem, index) => /*#__PURE__*/React.createElement(Grid, {
    sm: 6,
    xs: 12,
    item: true,
    key: index,
    className: classes.gridItemContent
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paperContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    color: "textPrimary"
  }, contentItem.header), contentItem.list.map((listItem, index) => listItem !== "" && /*#__PURE__*/React.createElement(Grid, {
    key: index,
    className: classes.listItem
  }, /*#__PURE__*/React.createElement(CompleteIncompleteIcon, {
    customCompleteContainer: classes.customCompleteContainer,
    complete: contentItem === null || contentItem === void 0 ? void 0 : contentItem.canAnswer,
    error: true
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textPrimary",
    className: classes.listItemText
  }, listItem))))))));
};
CanCannotAnswer.propTypes = {
  content: PropTypes.object.isRequired,
  leftSpaceContainer: PropTypes.string,
  bottomSpaceContainer: PropTypes.string
};
export default CanCannotAnswer;